import { Container } from "@material-ui/core";
import React from "react";
import Banner from "./Banner";
import Content from "./Content/Content";
import ControlledAccordions from "./ControlledAccordions";
import Header from "./Header";
import "./Homepage.css";
import Footer from "../Footer";

function Homepage() {
  return (
    <div className="homepage">
      {/* <Container maxWidth="xl"> */}
      <Header />
      {/* </Container> */}
      <hr
        style={{
          width: "95%",
          marginTop: "-30px",
          marginBottom: "30px",
          height: "2px",
          marginLeft: "2.5%",
        }}
      />
      <Banner />
      <Content />
      <ControlledAccordions />
      <Footer />
    </div>
  );
}
export default Homepage;
